
import Vue from 'vue'
import store from './../../store'
import notificationTransformer from '../../transformers/notification'

export default (notification) => {
  let  payload = notificationTransformer.notification.send(notification)
  return Vue.$http.put(`catalogs/common/notification/${notification.id}/`, payload)
    .then(response => {
        store.dispatch('alerts/removeAlert', notification)
    })
}



// WEBPACK FOOTER //
// ./src/services/notification/readNotificaion.js